import { toast } from 'sonner';
import { API } from '../../config/api';
import { DataService } from '../../config/dataService/dataService';
import { paramsToQueryString } from '../../utility/helpers/commonFunction';

export const getInventoryListApi = (params, partCategoryArray, partBrandArray, supplierArray, tireDimensionArray, tireModalArray) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);

            if (partCategoryArray && partCategoryArray?.length > 0) {
                partCategoryArray.forEach((item) => (queryString += `&partsCategory=${item}`));
            }

            if (partBrandArray && partBrandArray?.length > 0) {
                partBrandArray.forEach((item) => (queryString += `&partsBrand=${item}`));
            }

            if (supplierArray && supplierArray?.length > 0) {
                supplierArray.forEach((item) => (queryString += `&supplier=${item}`));
            }

            if (tireDimensionArray && tireDimensionArray?.length > 0) {
                tireDimensionArray.forEach((item) => (queryString += `&tyreDimension=${item}`));
            }
            if (tireModalArray && tireModalArray?.length > 0) {
                tireModalArray.forEach((item) => (queryString += `&tyreModel=${item}`));
            }

            const response = await DataService.get(API.inventory.getList + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.getList,
                    inventoryList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getInventoryListOptimizedApi = (params, partCategoryArray, partBrandArray, supplierArray, tireDimensionArray, tireModalArray) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);

            if (partCategoryArray && partCategoryArray?.length > 0) {
                partCategoryArray.forEach((item) => (queryString += `&partsCategory=${item}`));
            }

            if (partBrandArray && partBrandArray?.length > 0) {
                partBrandArray.forEach((item) => (queryString += `&partsBrand=${item}`));
            }

            if (supplierArray && supplierArray?.length > 0) {
                supplierArray.forEach((item) => (queryString += `&supplier=${item}`));
            }

            if (tireDimensionArray && tireDimensionArray?.length > 0) {
                tireDimensionArray.forEach((item) => (queryString += `&tyreDimension=${item}`));
            }
            if (tireModalArray && tireModalArray?.length > 0) {
                tireModalArray.forEach((item) => (queryString += `&tyreModel=${item}`));
            }

            const response = await DataService.get(API.inventory.getOptimizedList + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.getList,
                    inventoryList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getInventBatchListApi = (params) => {
    return async (dispatch) => {
        try {
            const queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.getBtachList + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.getBtachList,
                    inventoryBatchList: response.data,
                });
                return response.data?.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getInvcentoryPartDetailAPI = (params) => {
    return async (dispatch) => {
        try {
            const queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.getPartList + queryString);
            if (!response.data.error) {
                return response.data?.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getSingleInventoryApi = (id) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(API.inventory.getSingle + id);
            if (!response.data.error) {
                return response.data?.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getInventoryBatchDetailApi = (batchNumber) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(API.inventory.getBatch + batchNumber);
            if (!response.data.error) {
                return response.data?.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addInventoryApi = async (payload) => {
    try {
        const response = await DataService.post(API.inventory.create, payload);
        console.log('🚀 ~ addInventoryApi ~ response:', response);
        if (response.data.status) {
            toast.success(response?.data?.message);
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};
export const checkInventoryBeforeApi = async (payload) => {
    try {
        const response = await DataService.post(API.inventory.checkInventory, payload);
        if (response.data.status) {
            return response.data.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const updateInventoryApi = async (id, batchNumber, payload) => {
    try {
        const response = await DataService.put(API.inventory.update + id + '/' + batchNumber, payload);
        if (response.data.status) {
            toast.success(response?.data?.message);
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const getTireListApi = (params) => {
    return async (dispatch) => {
        try {
            // let queryString = paramsToQueryString(params);
            // const response = await DataService.get(
            //   API.inventory.parts.list + queryString
            // );
            // if (!response.data.error) {
            //   dispatch({
            //     type: API.inventory.parts.list,
            //     tireList: response.data,
            //   });
            //   return response.data;
            // } else {
            //   return false;
            // }
        } catch {
            return false;
        }
    };
};

// Parts Crud
export const getPartsListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.parts.list + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.parts.list,
                    partsList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getSupplierInvoiceList = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.supplierInvoiceList + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.supplierInvoiceList,
                    supplierInvoiceAray: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};
export const getInventoryFilterRecord = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.filter + queryString);
            if (!response.data.error) {
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};
export const addPartsApi = async (payload) => {
    try {
        const response = await DataService.post(API.inventory.parts.create, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const updatePartsApi = async (id, payload) => {
    try {
        const response = await DataService.put(API.inventory.parts.update + id, payload);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const deletePartsApi = async (id) => {
    try {
        const response = await DataService.put(API.inventory.parts.delete + id);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

// Parts Brand Crud
export const getPartsBrandListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.partsBand.list + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.partsBand.list,
                    partsBrandList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addPartsBrandApi = async (payload) => {
    try {
        const response = await DataService.post(API.inventory.partsBand.create, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

// Parts Category Crud
export const getPartsCategoryListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.partsCategory.list + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.partsCategory.list,
                    partsCategoryList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addPartsCategoryApi = async (payload) => {
    try {
        const response = await DataService.post(API.inventory.partsCategory.create, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

//Tyre Modal CRUD
export const getTyreModalListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.tyreModal.list + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.tyreModal.list,
                    tyreModalList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addTyreModalApi = async (payload) => {
    try {
        const response = await DataService.post(API.inventory.tyreModal.create, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

// Table view list filter get api // Parts Category Crud
export const getPartNumberForINventory = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.tableViewList.partNumber + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.tableViewList.partNumber,
                    inventoryPartNumber: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getTireDimensionForINventory = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.tableViewList.tyreDimension + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.tableViewList.tyreDimension,
                    inventoryTyreDimension: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getPartNameForINventory = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.tableViewList.partName + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.tableViewList.partName,
                    inventoryPartName: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getPartsCatgeoryForINventory = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.tableViewList.partCategory + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.tableViewList.partCategory,
                    inventoryPartsCategory: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getPartsBrandForINventory = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.tableViewList.partBrand + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.tableViewList.partBrand,
                    inventoryPartsBrand: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getTyreModelForINventory = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.tableViewList.tyreModel + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.tableViewList.tyreModel,
                    inventoryTyreModel: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const deleteInventoryApi = async (id, batchId) => {
    try {
        const response = await DataService.delete(API.inventory.delete + '/' + id + '/' + batchId);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};
export const getNextPartSequenceApi = () => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(API.inventory.partSequence);
            if (response.data.status) {
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};
